import Vue from 'vue'
import Vuex from 'vuex'

import SignalR from './modules/signalr'
import Viewer from './modules/viewer'
import Errors from './modules/errors'
import FlightBoard from './modules/flightBoard'
import LivePlan from './modules/livePlan'
import Workspaces from './modules/workspaces'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules: {
    SignalR,
    Viewer,
    Errors,
    FlightBoard,
    LivePlan,
    Workspaces
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js